import {Modal as GWCModal, ModalProps as GWCModalProps} from '@gwc/core'
import clsx from 'clsx'

import {classes} from './Modal.classes'
import {SidePanel} from './SidePanel'

export type ModalProps = Omit<GWCModalProps<'div'>, 'ref' | 'key'>

export const Modal = Object.assign(
  function Modalv2({
    disableAutoFocus = true,
    enableFocusOutside = true,
    className,
    children,
    onClose,
    backdrop = {},
    ...props
  }: ModalProps) {
    return (
      <GWCModal<'div'>
        {...props}
        backdrop={
          typeof backdrop === 'boolean'
            ? backdrop
            : {
                // @ts-expect-error "не понимается data-testid"
                'data-testid': 'modal.backdrop_click',
                ...backdrop,
                className: clsx(backdrop?.className, classes.backdrop),
              }
        }
        className={clsx(className, classes.modal)}
        disableAutoFocus={disableAutoFocus}
        enableFocusOutside={enableFocusOutside}
        onClose={onClose}
      >
        {children}
      </GWCModal>
    )
  },
  {
    Title: GWCModal.Title,
    Header: GWCModal.Header,
    Body: GWCModal.Body,
    Footer: GWCModal.Footer,
    SidePanel,
  },
)
